/* eslint-disable  react/no-deprecated */
/* eslint-disable  react/no-access-state-in-setstate */

import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { Modal } from 'react-bootstrap';
import EquipmentForm from 'components/modules/equipment/EquipmentForm';
import EquipmentStore from 'stores/EquipmentStore';
import SessionStore from 'stores/SessionStore';
import EquipmentActionCreators from 'actions/EquipmentActionCreators';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import classnames from 'classnames';
import { equipmentTypesMapping } from 'constants/Equipment';

class EquipmentEditModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    equipment: PropTypes.object.isRequired,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      equipment: props.equipment,
      audits: [],
      error: {},
      success: '',
      activeTab: 'Edit',
      isAdmin: SessionStore.isAdmin(),
    };
  }

  componentDidMount() {
    EquipmentStore.addEquipmentFormListener(this.handleStoreChange);
    EquipmentStore.addChangeListener(this.handleAuditsChange);
    if (this.props.equipment && this.props.equipment._id) {
      EquipmentActionCreators.getEquipmentAuditEvents(this.props.equipment._id);
    }
    SessionStore.addChangeListener(this.handleSessionStoreChange);
  }

  componentWillReceiveProps(props) {
    if (!this.props.show && props.show) {
      if (props.equipment && props.equipment._id) {
        EquipmentActionCreators.getEquipmentAuditEvents(props.equipment._id);
      }
      this.setState({
        equipment: props.equipment,
      });
    }
  }

  componentWillUnmount() {
    EquipmentStore.removeEquipmentFormListener(this.handleStoreChange);
    EquipmentStore.removeChangeListener(this.handleAuditsChange);
    SessionStore.removeChangeListener(this.handleSessionStoreChange);
  }

  handleSessionStoreChange = () => {
    const isAdmin = SessionStore.isAdmin();
    this.setState({
      isAdmin,
    });
  };

  handleAuditsChange = () => {
    let audits = [];

    if (this.state.equipment && this.state.equipment._id) {
      audits = EquipmentStore.getEquipmentAuditEvents(this.state.equipment._id);
    }

    this.setState({ audits });
  };

  handleStoreChange = () => {
    const { t } = this.props;
    const formStatus = EquipmentStore.getFormStatus();

    if (formStatus.success) {
      this.setState({
        error: {},
        success: t('EQUIPMENT_SUCCESSFULLY_UPDATED'),
      });
      setTimeout(() => this.handleHide(), 1500);
    } else {
      const error = { ...this.state.error };
      Object.keys(formStatus.error).forEach((key) => {
        error[key] = formStatus.error[key];
      });

      this.setState({
        error,
      });
    }
  };

  handleHide = () => {
    this.setState({
      equipment: null,
      error: {},
      success: {},
      activeTab: 'Edit',
    });
    this.props.onHide();
  };

  handleChange = (field, value) => {
    this.setState((currentState) => {
      const { equipment: currentEquipment } = currentState;

      const equipment = {
        ...currentEquipment,
        [field]: value,
      };

      /**
       * Reset chassis_owner_type and chassis_owner if is_private is set to false.
       */
      const fieldResetRequiredWhenToggleOff = field === 'is_private' && !value;
      if (fieldResetRequiredWhenToggleOff) {
        equipment.chassis_owner_type = null;
        equipment.chassis_owner = null;
      }

      /**
       * Below fields are not part of trailer and container,
       * so reset to default whenever _equipmentType changes
       */
      const fieldResetRequiredForNotChassisType =
        field === '_equipmentType' && value !== equipmentTypesMapping.CHASSIS;
      if (fieldResetRequiredForNotChassisType) {
        equipment.chassis_owner_type = null;
        equipment.chassis_owner = null;
        equipment.is_private = false;
      }
      /**
       * Below fields are not part of chassis and trailer,
       * so reset to default whenever _equipmentType changed to chassis or trailer
       */
      const fieldResetRequiredForNotContainer =
        field === '_equipmentType' && value !== equipmentTypesMapping.CONTAINER;
      if (fieldResetRequiredForNotContainer) {
        equipment._equipmentSize = null;
        equipment._type = null;
      }

      return {
        equipment,
      };
    });
  };

  handleSave = () => this.props.onSave(this.state.equipment);

  componentToRender() {
    if (this.state.activeTab === 'Edit') {
      return (
        <EquipmentForm
          equipment={this.state.equipment}
          error={this.state.error}
          success={this.state.success}
          onFieldChange={this.handleChange}
          onSave={this.handleSave}
          onCancel={this.handleHide}
          isAdmin={this.state.isAdmin}
        />
      );
    }
    return <AuditHistory audits={this.state.audits} paginate />;
  }

  renderTabs() {
    const { t } = this.props;
    if (!this.state.isAdmin) {
      return null;
    }
    const activeTab = {
      'bg-white': true,
      'inline-block': true,
      'border-solid': true,
      'border-l': true,
      'border-t': true,
      'border-r': true,
      'border-grey-light': true,
      'rounded-t': true,
      'py-2': true,
      'px-4': true,
      'text-blue-dark': true,
      'font-semibold': true,
      'text-grey': false,
    };
    const tab = {
      'bg-white': true,
      'inline-block': true,
      'py-2': true,
      'px-4': true,
      'text-grey': true,
      'text-blue-hover:text-blue': true,
      'font-semibold': true,
      'no-underline': true,
    };
    return (
      <ul
        style={{
          marginLeft: '2px',
          textDecoration: 'none',
        }}
        className="flex no-underline border-b border-solid list-reset border-grey-light"
      >
        <li className="mr-1 -mb-px">
          <a
            style={{
              textDecoration: 'none',
            }}
            className={classnames({
              ...tab,
              ...(this.state.activeTab === 'Edit' ? activeTab : {}),
            })}
            onClick={() => this.setState({ activeTab: 'Edit' })}
          >
            {titleize(t('EDIT'))}
          </a>
        </li>
        <li className="mr-1">
          <a
            style={{
              textDecoration: 'none',
            }}
            className={classnames({
              ...tab,
              ...(this.state.activeTab === 'Audit' ? activeTab : {}),
            })}
            onClick={() => this.setState({ activeTab: 'Audit' })}
          >
            {t('AUDIT_HISTORY')}
          </a>
        </li>
      </ul>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={this.handleHide}>
        <Modal.Header style={{ border: 'none' }} closeButton>
          <Modal.Title>{titleize(t('EDIT_EQUIPMENT'))}</Modal.Title>
        </Modal.Header>
        {this.renderTabs()}
        <Modal.Body>{this.componentToRender()}</Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(EquipmentEditModal);
